// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ncN4Q3sgmBV0Fxa3OUvY5","inputs":"zZuRRsQkPHOfrE3AAmgQE","label":"_1W1uLkNW4APj-DBae68GA0"};